import AlertBox from "@components/AlertBox/AlertBox"
import Header from "@components/Header/Header"
import MenuItem from "@components/MenuItem/MenuItem"
import SectionLabel from "@components/SectionLabel/SectionLabel"
import { CRIMSON_100 } from "@styles/colors"
import { useNavigate } from "react-router"
import { Container, ContentContainer, MenuItemsContainer, AlertBoxContainer } from "./BankAndAddress.styles"
import { useTranslation } from "react-i18next"
import { useUserRestrictions } from "@hooks/useUserRestrictions"

const BankAndAddress = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { canRedeemToBank, canTransfer, canRedeemToEwallet } = useUserRestrictions()
    return (
        <Container>
            <Header title={t('bankAndAddress.header')} showBackButton={true} onBackClick={() => navigate('/settings')} />
            <ContentContainer>
                <SectionLabel>{t('bankAndAddress.sectionLabel')}</SectionLabel>
                <MenuItemsContainer>
                    {canRedeemToBank() && <MenuItem
                        title={t('bankAndAddress.menuItems.manageBank')}
                        onClick={() => navigate('/manage-bank')}
                        iconType="edit"
                    />}
                    {canTransfer() && <MenuItem
                        title={t('bankAndAddress.menuItems.manageAddress')}
                        onClick={() => navigate('/manage-address')}
                        iconType="edit"
                    />}
                    {canRedeemToEwallet() && <MenuItem
                        title={t('bankAndAddress.menuItems.manageEWallet')}
                        onClick={() => navigate('/manage-e-wallet')}
                        iconType="edit"
                    />}
                </MenuItemsContainer>
            </ContentContainer>
            <AlertBoxContainer>
                <AlertBox
                    alertText={t('bankAndAddress.alertText')}
                    textAlign="center"
                    enableIcon={false}
                    backgroundColor={CRIMSON_100}
                    borderColor={CRIMSON_100}
                    fontSize="14px"
                />
            </AlertBoxContainer>
        </Container>
    )
}

export default BankAndAddress